import { contractTab } from './contract_tab';
import { billTab } from './bill_tab';
import { incubatorList } from './incubator_list';
import { payableStatis } from './payable_statis';
import { incubatorBase } from './incubator_base';
import { wbTabCurrent } from './wb_tab_current';
import { invoiceTodoList } from './invoice/invoice_todo_list';
import { incuCustomList } from './incu_custom_list';

export default {
  contract_tab: contractTab,
  bill_tab: billTab,
  incubator_list: incubatorList,
  payable_statis: payableStatis,
  incubator_base: incubatorBase,
  wb_tab_current: wbTabCurrent,
  incu_custom_list: incuCustomList,
  invoice_todo_list: invoiceTodoList,
};



// WEBPACK FOOTER //
// ./src/store/modules/incubator/reducers.js